// Get Chat Creator Details
export const GET_CHAT_CREATOR_DETAILS_REQUEST = 'GET_CHAT_CREATOR_DETAILS_REQUEST';
export const GET_CHAT_CREATOR_DETAILS_DONE = 'GET_CHAT_CREATOR_DETAILS_DONE';
export const GET_CHAT_CREATOR_DETAILS_FAILED = 'GET_CHAT_CREATOR_DETAILS_FAILED';

export const GET_CHAT_CREATOR_DETAILS_RESET = 'GET_CHAT_CREATOR_DETAILS_RESET';
